module.exports = __webpack_public_path__ + "static/media/womenwithtab.13696d0f.svg";